(function () {
  function initializePrimoPages(scope) {
    var root = scope || document;

    root.querySelectorAll('#PrimoContactForm, #PrimoHelpContactForm').forEach(function (form) {
      if (form.dataset.primoReady === 'true') return;
      form.dataset.primoReady = 'true';
      form.addEventListener('submit', function () {
        var firstName = form.querySelector('[name="contact[first_name]"]');
        var lastName = form.querySelector('[name="contact[last_name]"]');
        var fullName = form.querySelector('[name="contact[name]"]');
        if (!fullName) return;
        fullName.value = [firstName && firstName.value, lastName && lastName.value].filter(Boolean).join(' ').trim();
      });
    });

    root.querySelectorAll('[data-help-search]').forEach(function (input) {
      if (input.dataset.primoReady === 'true') return;
      input.dataset.primoReady = 'true';
      var page = input.closest('[data-helpcenter]');
      if (!page) return;
      var empty = page.querySelector('[data-help-empty]');
      input.addEventListener('input', function () {
        var query = input.value.trim().toLowerCase();
        var visibleCount = 0;
        page.querySelectorAll('[data-help-item]').forEach(function (item) {
          var visible = !query || item.textContent.toLowerCase().indexOf(query) !== -1;
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        page.querySelectorAll('[data-help-group]').forEach(function (group) {
          group.hidden = query && !group.querySelector('[data-help-item]:not([hidden])');
        });
        page.querySelectorAll('[data-help-section]').forEach(function (section) {
          section.hidden = query && !section.querySelector('[data-help-item]:not([hidden])');
        });
        if (empty) empty.style.display = query && visibleCount === 0 ? 'block' : 'none';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initializePrimoPages(document); });
  document.addEventListener('shopify:section:load', function (event) { initializePrimoPages(event.target); });
})();
